/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { CMSLink } from "../../components/CMSLink"
import { SectionGrid, Flex } from "frontend/src/components/Layout"

function LegalFooter({ copyright, links }) {
  return (
    <SectionGrid sx={{ bg: "black", height: [44, 44, 50] }}>
      <SectionGrid.narrow>
        <Flex.column justify="center">
          <Flex.row
            justify="space-between"
            align="center"
            sx={{ margin: "auto", height: [28, 28, 50], width: "100%" }}
          >
            <div sx={{ display: ["none", "none", "block"], flexBasis: "30%", my: "auto" }}>
              <span sx={{ variant: "text.body2", color: "white" }}>
                {`©  ${new Date().getFullYear()} ${copyright}`}
              </span>
            </div>
            <Flex.row justify="space-between" sx={{ flexBasis: "70%", mx: [5, 10, "unset"] }}>
              {links.map((link, i) => (
                <div
                  key={link.externalUrl || link.internalRef?.current?.slug || i}
                  sx={{ mx: ["2px", "5px", "10px"] }}
                >
                  <CMSLink link={link} sx={{ variant: "text.body2", color: "white" }} />
                </div>
              ))}
            </Flex.row>
          </Flex.row>
        </Flex.column>
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { LegalFooter }
